import * as React from 'react';
import MaterialUIBadge, { BadgeProps } from '@material-ui/core/Badge';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'inline-flex'
    },
    badge: {
      width: 'auto',
      fontSize: theme.typography.pxToRem(10),
      transform: 'none',
      position: 'relative',
      marginLeft: 5
    },
    invisible: {
      display: 'none'
    },
    linkText: {
      minWidth: 0, // prevents badge from disappearing when text runs long
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  });

type Props = WithStyles<typeof styles> & Partial<BadgeProps>;

const BadgeComponent: React.FC<Props> = ({ id, badgeContent, classes, children, color = 'error' }) => {
  const { t } = useTranslation();
  const renderChildren = <span className={classes.linkText}>{children}</span>;
  const itemsCount = Number(badgeContent);
  return (
    <MaterialUIBadge
      id={id}
      badgeContent={badgeContent}
      children={renderChildren}
      classes={{
        root: classes.root,
        badge: classes.badge,
        invisible: classes.invisible
      }}
      color={color}
      title={t('components.badgeTooltip', {
        count: itemsCount,
        defaultValue_plural: 'items require action',
        defaultValue: 'item requires action'
      })}
    />
  );
};

export const InlineBadge = withStyles(styles)(BadgeComponent);
